import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { KeyValueType } from '@models/common';
import { ListResponse } from '@models/helpers';
import { HttpService } from '@shared/services';

import { PaymentPeriodCUDResponse, PaymentPeriodModel } from './api-models/payment-period.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentPeriodService {
  private http = inject(HttpService);

  searchPeriods(entityInstanceId: number) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http
      .post<ListResponse<PaymentPeriodModel>>(
        '_api/PaymentPeriod/Search',
        {},
        {
          httpOptions: { params },
          useLoader: false,
        },
      )
      .pipe(map(response => response?.data ?? []));
  }

  recreatePeriods(entityInstanceId: number) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.put<void>('_api/PaymentPeriod/RecreatePaymentPeriods', null, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  createPeriod(entityInstanceId: number, endDate: string) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.post<PaymentPeriodCUDResponse>(
      '_api/PaymentPeriod/Create',
      { endDate },
      {
        httpOptions: { params },
        useLoader: false,
      },
    );
  }

  updatePeriod(entityInstanceId: number, id: number, endDate: string) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.put<PaymentPeriodCUDResponse>(
      '_api/PaymentPeriod/Update',
      { id, endDate },
      {
        httpOptions: { params },
        useLoader: false,
      },
    );
  }

  deletePeriod(entityInstanceId: number, id: number) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.put<PaymentPeriodCUDResponse>(
      '_api/PaymentPeriod/Delete',
      { id },
      {
        httpOptions: { params },
        useLoader: false,
      },
    );
  }

  combinePeriods(entityInstanceId: number, ids: number[]) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.put<void>('_api/PaymentPeriod/CombinePeriods', ids, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  undoCombinePeriods(periodId: number) {
    const params = this.http.buildHttpParams({ id: periodId });
    return this.http.put<void>('_api/PaymentPeriod/UndoCombinePeriods', null, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  getPeriodBoundaryDates(entityInstanceId: number, isStartDate: boolean, orderAscending: boolean) {
    const params = this.http.buildHttpParams({ entityInstanceId, isStartDate, orderAscending });
    return this.http.get<KeyValueType<string, string>[]>('_api/PaymentPeriod/GetPeriodStartEndDate', {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
